import { getConsent } from '@/pages/avatar/api';
import { CreateAvatarStoreProvider } from '@/pages/avatar/common/context';
import { AvatarType, Consent } from '@/pages/avatar/common/types';
import { logger } from '@/services/logger';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AvatarPage } from './AvatarPage';

export const AvatarEditPage = () => {
    const [loading, setLoading] = useState(true);
    const [consent, setConsent] = useState<Consent | null>(null);
    const { state } = useLocation();

    useEffect(() => {
        if (!state.consent_id) {
            setLoading(false);
            return;
        }

        getConsent(state.consent_id)
            .then(consent => {
                setConsent(consent);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
                logger.error('failed to fetch consent', { consentId: state.consent_id, error });
            });
    }, []);

    if (loading) {
        return null;
    }

    return (
        <CreateAvatarStoreProvider initialValues={{ id: state.id, footageUrl: state.source_url, consent }} type={AvatarType.Express}>
            <AvatarPage />
        </CreateAvatarStoreProvider>
    );
};
